import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppConfig } from '@app/config/app.config';
import { LoginGuardService } from './auth/login-guard.service';
import { CqesLoginComponent } from './auth/component/login/cqes-login/cqes-login.component';

const routes: Routes = [
  {
    path: AppConfig.routes.login,
    component: CqesLoginComponent,
    canActivate: [LoginGuardService],
    data: {
      title: AppConfig.routes.login
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
